/**
 * RequirementFormModal — `control_id` select is a SELF-REFERENCE to
 * the Step 8 controls list (injected at render time from the same
 * agent's `cybersecurity_controls` array).
 */
import React, { useMemo } from 'react';
import FormModal from '../../../../components/ui/FormModal/FormModal';
import { REQUIREMENT_FORM_FIELDS, type RequirementRecord } from './requirementsFieldSchema';

const FormModalAny = FormModal as unknown as React.ComponentType<any>;

export interface OptionLite { value: string; label: string; }

export interface RequirementFormModalProps {
  mode: 'add' | 'edit';
  initialReq?: RequirementRecord | null;
  controlOptions: OptionLite[];
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onClose: () => void;
}

export default function RequirementFormModal({
  mode,
  initialReq,
  controlOptions,
  onSubmit,
  onClose,
}: RequirementFormModalProps) {
  const isEdit = mode === 'edit';
  const fields = useMemo(
    () => REQUIREMENT_FORM_FIELDS.map((f) => {
      if (f.name === 'control_id') return { ...f, options: controlOptions };
      if (isEdit && f.name === 'req_id') return { ...f, disabled: true };
      return f;
    }),
    [controlOptions, isEdit],
  );

  return (
    <FormModalAny
      title={isEdit ? 'Edit Requirement' : 'Add Requirement'}
      fields={fields}
      initialValues={initialReq ?? {}}
      submitLabel={isEdit ? 'Save Changes' : 'Add Requirement'}
      submittingLabel={isEdit ? 'Saving…' : 'Adding…'}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth={720}
    />
  );
}
